import { TextField } from '@material-ui/core';
import React, { Component } from 'react';
import { QuestionTypes } from '../../../../constants/QuestionTypes';
import { getAnswersWithSkip } from '../../../../services/formService';
import { stripPTag } from '../../../common/commonFuncs';
import QAFooter from "./QAFooter";
class TypeNumeric extends Component {
	constructor(props) {
		super(props);

		this.state = {
			Question_ID: this.props.Question_ID,
			isTally: this.props.isTally,
			allowLeadingZero: this.props.allowLeadingZero,
			minimumNumber: 0,
			maximumNumber: 1,
			origStates: {
				minimumNumber: 0,
				maximumNumber: 1
			}
		};
	}

	async componentDidMount() {
		let { data: Question_Answers } = await getAnswersWithSkip(this.state.Question_ID);
		if (Question_Answers.length !== 0) {
			const [minimumNumberObj,maximumNumberObj]=Question_Answers;
			const {Answer_Text:minimumNumber} = minimumNumberObj;
			const {Answer_Text:maximumNumber} = maximumNumberObj;
			this.setState({
				minimumNumber,
				maximumNumber,
				origStates: {
					minimumNumber,
					maximumNumber
				}
			});
		}
		// disable re-map responses if this is a newly created widget that has not been saved yet
		if (Question_Answers.length === 0) this.props.setRemapResponses(false);
	}

	handleSave = async () => {
		const { minimumNumber, maximumNumber } = this.state;
		const Question_ID = await this.props.onSave([
			{ Answer_ID: 0, Answer_Text: minimumNumber, SkipLogic: [] },
			{ Answer_ID: 0, Answer_Text: maximumNumber, SkipLogic: [] },
		]);
		this.setState({
			Question_ID,
			origStates: {
				minimumNumber,
				maximumNumber
			}
		});
	};

	handleRemove = () => {
		this.props.onRemove();
	};

	handleChange = () => {
		let { isTally } = this.state;
		isTally = !isTally;
		if (isTally) {
			this.props.onTypeChange(QuestionTypes.Numeric_Tally);
		} else {
			this.props.onTypeChange(QuestionTypes.Numeric);
		}
		this.setState({ isTally });
	};

	handleRangeChange = (e) => {
		const { name, value } = e.target;
		const { minimumNumber, maximumNumber } = this.state;

		if ((name === 'minimumNumber' && value < maximumNumber) || (name === 'maximumNumber' && value > minimumNumber)) {
			this.setState({ [name]: value });
		}
	};

	handleAllowLeadingZeroChange = () => {
		let { allowLeadingZero } = this.state;
		allowLeadingZero = !allowLeadingZero;
		this.props.onAllowLeadingZeroChange(allowLeadingZero)
		this.setState({ allowLeadingZero });
	}

	parseToSave = () => {
		let result = [...this.state.Question_Answers];
		result.map((ans) => {
			ans.Answer_Text = stripPTag(ans.Answer_Text);
		});
		return result;
	};

	/**
	 * Allow re-mapping responses if min and max numbers have NOT been changed
	 * from what is currently saved.
	 * @returns {boolean} True if allowed, False otherwise
	 */
	verifyRemapResponses = () => {
		const origStates = this.state.origStates;
		return origStates.minimumNumber === this.state.minimumNumber &&
			origStates.maximumNumber === this.state.maximumNumber;
	}

	render() {
		const { minimumNumber, maximumNumber } = this.state;

		return (
			<React.Fragment>
				<div className='form-group'>
					<TextField
						// id={Question_ID + "Description"}
						label='Mininum number'
						value={minimumNumber}
						name='minimumNumber'
						variant='outlined'
						type='number'
						inputProps={{ min: '0' }}
						onChange={(e) => this.handleRangeChange(e)}
					/>
					<TextField
						// id={Question_ID + "Description"}
						label='Maximum Number'
						value={maximumNumber}
						name='maximumNumber'
						variant='outlined'
						type='number'
						inputProps={{ min: '0' }}
						onChange={(e) => this.handleRangeChange(e)}
					/>
				</div>
				<div className='form-check'>
					<input type='checkbox' className='form-check-input' id='isTally' name='tally' checked={this.state.isTally} onChange={this.handleChange} />
					<label htmlFor='isTally' className='form-check-label'>
						Is Tally
					</label>
				</div>
				<div className='form-check'>
					<input type='checkbox' className='form-check-input' id='allowLeadingZero' name='allowLeadingZero' checked={this.state.allowLeadingZero} onChange={this.handleAllowLeadingZeroChange} />
					<label htmlFor='allowLeadingZero' className='form-check-label'>
						Allow Leading Zero
					</label>
				</div>

				<QAFooter Widget_ID={this.props.Widget_ID}
						  handleSave={this.handleSave}
						  handleRemove={this.handleRemove}
						  showRemapResponses={true}
						  remapResponses={this.props.remapResponses}
						  setRemapResponses={this.props.setRemapResponses}
						  verifyRemapResponses={this.verifyRemapResponses}/>
			</React.Fragment>
		);
	}
}

export default TypeNumeric;
